import api from './api';

export const orderService = {
  getAll: () => api.get('/orders/'),
  getById: (id) => api.get(`/orders/${id}/`),
  create: (data) => api.post('/orders/', data),
  pay: (id) => api.post(`/orders/${id}/pay/`),
  verify: (data) => api.post('/orders/verify/', data),
};

export const paymentService = {
  createPayment: (orderId) => api.post(`/orders/${orderId}/pay/`),
  verifyPayment: (authority, status) => api.post('/orders/verify/', { authority, status }),
};